"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelValidationError = exports.ValidationErrorEnum = void 0;
var lodash_1 = require("lodash");
var ValidationErrorEnum;
(function (ValidationErrorEnum) {
  ValidationErrorEnum[ValidationErrorEnum["typeof_date"] = 1] = "typeof_date";
  ValidationErrorEnum[ValidationErrorEnum["typeof_string"] = 2] = "typeof_string";
  ValidationErrorEnum[ValidationErrorEnum["typeof_number"] = 3] = "typeof_number";
  ValidationErrorEnum[ValidationErrorEnum["typeof_integer"] = 4] = "typeof_integer";
  ValidationErrorEnum[ValidationErrorEnum["typeof_boolean"] = 5] = "typeof_boolean";
  ValidationErrorEnum[ValidationErrorEnum["instance_of"] = 6] = "instance_of";
  ValidationErrorEnum[ValidationErrorEnum["min_length"] = 7] = "min_length";
  ValidationErrorEnum[ValidationErrorEnum["max_length"] = 8] = "max_length";
  ValidationErrorEnum[ValidationErrorEnum["min_value"] = 9] = "min_value";
  ValidationErrorEnum[ValidationErrorEnum["max_value"] = 10] = "max_value";
  ValidationErrorEnum[ValidationErrorEnum["defined"] = 11] = "defined";
  ValidationErrorEnum[ValidationErrorEnum["equal"] = 12] = "equal";
  ValidationErrorEnum[ValidationErrorEnum["not_equal"] = 13] = "not_equal";
  ValidationErrorEnum[ValidationErrorEnum["greater"] = 14] = "greater";
  ValidationErrorEnum[ValidationErrorEnum["greater_or_equal"] = 15] = "greater_or_equal";
  ValidationErrorEnum[ValidationErrorEnum["less"] = 16] = "less";
  ValidationErrorEnum[ValidationErrorEnum["less_or_equal"] = 17] = "less_or_equal";
  ValidationErrorEnum[ValidationErrorEnum["in"] = 18] = "in";
  ValidationErrorEnum[ValidationErrorEnum["not_in"] = 19] = "not_in";
  ValidationErrorEnum[ValidationErrorEnum["match"] = 20] = "match";
  ValidationErrorEnum[ValidationErrorEnum["not_match"] = 21] = "not_match";
  ValidationErrorEnum[ValidationErrorEnum["between"] = 23] = "between";
  ValidationErrorEnum[ValidationErrorEnum["not_between"] = 24] = "not_between";
})(ValidationErrorEnum = exports.ValidationErrorEnum || (exports.ValidationErrorEnum = {}));
var ModelValidationError = /** @class */function () {
  function ModelValidationError(values) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, this.getClassProperties()));
  }
  ModelValidationError.prototype.getClassProperties = function () {
    return ['model', 'property', 'value', 'error', 'stack', 'details', 'expected'];
  };
  return ModelValidationError;
}();
exports.ModelValidationError = ModelValidationError;
